import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { LogoStacked } from '../components/Logo';

export function OwnerOnboarding() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [dob, setDob] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await api.completeProfile(email.trim().toLowerCase(), dob);
      setSent(true);
    } catch (e: any) {
      setErr(e.message || 'failed');
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <div className="app">
        <div className="auth-hero">
          <LogoStacked />
          <h1 className="display auth-title">Check your email.</h1>
          <p className="muted auth-sub">
            We sent a verification link to <strong>{email}</strong>. Click it to activate your admin powers.
          </p>
          <button className="btn secondary block" onClick={() => nav('/')}>Back to your cove</button>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="auth-hero">
        <LogoStacked />
        <h1 className="display auth-title">Finish setting up.</h1>
        <p className="muted auth-sub">
          As the owner, we need your email and date of birth before you can invite anyone or make role changes.
          Kids and other members are unaffected.
        </p>
        <form className="auth-form" onSubmit={submit}>
          <label className="field">
            <span className="field-label">Your email</span>
            <input
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              autoCapitalize="none"
            />
          </label>
          <label className="field">
            <span className="field-label">Your date of birth</span>
            <input
              className="input"
              type="date"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              max={new Date(Date.now() - 18 * 365.25 * 86400_000).toISOString().slice(0, 10)}
            />
          </label>
          {err && <div className="error">{err}</div>}
          <button className="btn block" type="submit" disabled={busy || !email.includes('@') || !/^\d{4}-\d{2}-\d{2}$/.test(dob)}>
            {busy ? 'Sending…' : 'Send verification email'}
          </button>
        </form>
      </div>
    </div>
  );
}
